import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { CAMPAIGN_NAMES } from 'constants/personalizations';
import NotFoundPageContainer from 'containers/NotFoundPageContainer';
import NotFoundPageExploreMoreContainer from 'containers/NotFoundPageExploreMoreContainer';
import NotFoundPageRecsContainer from 'containers/NotFoundPageRecsContainer';
import * as actions from 'state/actions';

const NotFoundController = class {
  static mountNotFound = store => {
    ReactDOM.render(
      <Provider store={store}>
        <NotFoundPageContainer />
      </Provider>,
      document.getElementById('page-404-container')
    );
  };

  static mountNotFoundRecs = store => {
    ReactDOM.render(
      <Provider store={store}>
        <NotFoundPageRecsContainer />
      </Provider>,
      document.getElementById('page-404-recs-container')
    );
  };

  static mountNotFoundExploreMore = store => {
    ReactDOM.render(
      <Provider store={store}>
        <NotFoundPageExploreMoreContainer />
      </Provider>,
      document.getElementById('page-404-explore-more-container')
    );
  };

  static fetchDyCampaigns = store => {
    store.dispatch(
      actions.fetchPersonalizations({
        names: [CAMPAIGN_NAMES.NOT_FOUND_RECS],
      })
    );
  };

  static init = store => {
    NotFoundController.fetchDyCampaigns(store);
    NotFoundController.mountNotFound(store);
    NotFoundController.mountNotFoundRecs(store);
    NotFoundController.mountNotFoundExploreMore(store);
  };
};

export default NotFoundController;
